export enum VideoPlatform {
  youtube = 'youtube',
  vimeo = 'vimeo',
  loom = 'loom',
}
